import drcBranchesGroupedByBank from '../../../assets/data/drc-branches-grouped-by-bank.json';
import { DrcBranchDetails } from '@shared/documents-upload-drc/models';

export const DRCBranchList = drcBranchesGroupedByBank as Record<string, DrcBranchDetails[]>;
